import React from 'react';
import type { AttributeType } from '@/api/models';
import { AttributeValuesSheetView } from './AttributeValuesSheetView';
import { useAttributeValuesSheet } from './useAttributeValuesSheet';

type AttributeValuesSheetProps = {
    isOpen: boolean;
    onClose: () => void;
    type: AttributeType | null;
};

/**
 * Container for the values drawer of one attribute type. Instantiates the
 * value/alias logic hook and hands its output to the render-only View. Editing
 * here is global — these values are shared by every category that uses the type.
 */
export const AttributeValuesSheet: React.FC<AttributeValuesSheetProps> = ({
    isOpen,
    onClose,
    type,
}) => {
    const sheet = useAttributeValuesSheet(type);

    return (
        <AttributeValuesSheetView
            isOpen={isOpen}
            onClose={onClose}
            sheet={sheet}
            type={type}
        />
    );
};
